"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.setCardInScenarioDeckState = function (characterType, card) {
        localStorage.setItem("scenarioDeck." + characterType + "." + card.name, String(card.inScenarioDeck));
    };
    LocalStorageService.prototype.getCardInScenarioDeckState = function (characterType, cardName) {
        var value = localStorage.getItem("scenarioDeck." + characterType + "." + cardName);
        return value != null ? (value === "true") : false;
    };
    LocalStorageService.prototype.getSelectedCharacter = function () {
        // @ts-ignore
        return localStorage.getItem("lastSelectedCharacter") || "scoundrel";
    };
    LocalStorageService.prototype.setSelectedCharacter = function (selectedCharacter) {
        return localStorage.setItem("lastSelectedCharacter", selectedCharacter);
    };
    LocalStorageService.prototype.getCharacterLevel = function (characterType) {
        var level = localStorage.getItem("level." + characterType);
        return level != null ? Number(level) : 1;
    };
    LocalStorageService.prototype.setCharacterLevel = function (characterType, level) {
        localStorage.setItem("level." + characterType, String(level));
    };
    LocalStorageService.prototype.setCardInPlayerDeckState = function (characterType, card) {
        localStorage.setItem("playerDeck." + characterType + "." + card.name, String(card.inPlayerDeck));
    };
    LocalStorageService.prototype.getCardInPlayerDeckState = function (characterType, cardName) {
        var value = localStorage.getItem("playerDeck." + characterType + "." + cardName);
        return value != null ? (value === "true") : false;
    };
    return LocalStorageService;
}());
exports.LocalStorageService = LocalStorageService;



//////////////////
// WEBPACK FOOTER
// ./src/services/LocalStorageService.ts
// module id = 6028
// module chunks = 0